<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted: async function () {
    /* eslint-disable */
    // this.$bvToast.toast('系統正在開發測試中，請靜待開放通知! This service is under developing!', {
    //   title: '系統開發中',
    //   autoHideDelay: 3000
    // })
    /* eslint-enable */
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue